import * as Types from '../types';
import { Route } from 'components/Router/types';

/**
 * Helper function to convert a set of Routes to an array
 * of InternalLinkNavItem.
 *
 * @param routes
 */
const routesToNavigationItems = (routes: Route[]): Types.InternalLinkNavItem[] => {
  return routes.map(
    (route: Route): Types.InternalLinkNavItem => {
      return {
        route,
        Icon: route.Icon,
      };
    },
  );
};

export default routesToNavigationItems;
